/**
 * @file CSVダウンロード
 *
 */
'use strict';
import Common from "../../Utils/Common";
 
/**
 * @classname OutputAccidentsListExcel
 * @classdesc CSVダウンロード
 */
export default class OutputAccidentsListExcel {
	/**
	 * @constructor
	 * @param {object} controller - controllerオブジェクト
	 * @param {jQuery} $e - $('.btn-output-accidents-list-excel')
	 */
	constructor($e, controller) {
		console.log('OutputAccidentsListExcel.constructor')
		this._$e = $e
		this._params = Common.getParam()
		this._$e.on('click', () => this.onClick())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof OutputAccidentsListExcel
	 * @return {undefined}
	 */
	onClick() {
		console.log('OutputAccidentsListExcel.onClick')
		location.href = window.const.API_URL.DOWNLOAD_ACCIDENTS_LIST_EXCEL
	}
 }
 